import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { SECTION_KEYS } from '../../constants/sections';
import { useCheckout } from '../../hooks/useCheckout';
import CheckoutCard from '../CheckoutCard';
import EditView from './EditView';
import SummaryView from './SummaryView';

function BusinessInfoCard({ hideEdit, sectionNumber }) {
  const { formState } = useFormContext();
  const { validSections } = useCheckout();

  const sectionKey = SECTION_KEYS.BUSINESS_INFO;
  const isValid = validSections[sectionKey];

  const showSubtitle = !isValid && !formState.isSubmitted;

  // TODO: translate strings
  const title = 'Company name';
  const subtitle = showSubtitle ? "We couldn't find your company name." : null;

  return (
    <CheckoutCard
      hideEdit={hideEdit}
      sectionKey={sectionKey}
      sectionNumber={sectionNumber}
      subtitle={subtitle}
      title={title}
    >
      <CheckoutCard.Summary>
        <SummaryView sectionKey={sectionKey} />
      </CheckoutCard.Summary>
      <CheckoutCard.Edit>
        <EditView sectionKey={sectionKey} />
      </CheckoutCard.Edit>
    </CheckoutCard>
  );
}

BusinessInfoCard.propTypes = {
  hideEdit: PropTypes.bool,
  sectionNumber: PropTypes.number.isRequired
};

export default BusinessInfoCard;
